import styled from 'styled-components'
import theme from 'theme_'

export const StatusCardHeaderFrame = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;

  width: 100%;
  height: 50%;

  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
`
export const StatusCardInfoFrame = styled.div`
  /* Frame 626109 */

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 8px;
  margin-left: 3%;
  margin-top: 2%;
  width: 100%;
  height: 100%;

  flex: none;
  order: 0;
  flex-grow: 1;
`
export const StatusCardInnerFrame = styled.div`
  /* Frame 626109 */

  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;
  gap: 8px;

  width: 97%;
  height: 95%;

  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
`
export const StatusCardPercentage = styled.div`
  /* Frame 33 */

  display: flex;
  flex-direction: row;
  align-items: flex-end;
  padding: 0px;

  width: 100%;
  height: 32px;

  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 0;
`
export const StatusCardHeaderText = styled.span`
  /* PROFILES */

  width: fit-content;
  height: 32px;

  font-family: Montserrat;

  font-style: normal;
  font-weight: 750;
  font-size: 14px;
  line-height: 16px;
  /* or 114% */

  color: ${theme.colors.otterWarmBlack};

  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 1;
`
export const StatusCardAverageLableText = styled.span`
    lineheight=26px;
    font-weight: 900;
    font-size: 24px;
    font-style: normal;
    flex: none;
    order: 0;
`
export const StatusCardAverageText = styled.span`
  font-weight: 900;
  font-size: 32px;
`

export const StatusCardMainWrapper = styled.div<{
  status?: number
}>`
  /* network status card */

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 12px 16px 16px;
  gap: 16px;

  height: 100px;
  max-width: 250px;

  /* Green 10% */
  background: #f4fcf3;
  /* Shadow small */
  box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.01);
  border-radius: 8px;

  flex: none;
  order: 0;
  flex-grow: 1;
  margin: 4px;

  @media ${theme.devices.mobile} {
    width: 100%;
    max-width: 700px;
    margin-bottom: 15px;
  }
`
